import { defineComponent } from 'vue'
import type { Contact } from '#models/contact'

export default defineComponent({
  props: {
    contact: {
      type: Object as () => Contact,
      required: true
    }
  }
})
